module.exports = __webpack_public_path__ + "img/uplus-mark.586eca7a.png";